import * as React from "react"
import type { SVGProps } from "react"
const SvgCube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 19.85V13L5 9.53v6.85zm2 0 6-3.47V9.53L13 13zm-1-8.57 5.93-3.43L12 4.43 6.08 7.85zm-8 6.85a2 2 0 0 1-1-1.73V8.45a2 2 0 0 1 1-1.72l7-4.03a2 2 0 0 1 2 0l7 4.03a2 2 0 0 1 1 1.72v7.95a2 2 0 0 1-1 1.73l-7 4.02a2 2 0 0 1-2 0z" />
  </svg>
)
export default SvgCube
